export const dataFetchActionType = {
  loading: "Loading",
  error: "Error",
  data: "Data",
};
